import React, { useEffect, useRef, useState } from "react";
import { Divider, Typography, Form, notification, Spin } from "antd";
import "./InforDetail.scss";
import DetailTabInfo from "./DetailTabInfo/DetailTabInfo";
import { fieldsInforDetail1, fieldsInforDetail2 } from "./inforDetail.config";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { medicalExaminationService, examinationService } from "api";
import {
  convertIosStringToDate,
  disableBtn,
  dispatchCurrentRoom,
  getItemLocalStorage,
  isValuable,
} from "helper/common";
import { StepInfo } from "components/common";
import {
  setDataChanDoan,
  setDataPhieu,
  setIdPKNT,
  setIdReceiptExamOut,
} from "redux/reducer/examination";

import { TEN_PHONG, tabKeys } from "types/enums";
import {
  getListPhongAPI,
  setActiveKey,
  setButtonsHeader,
  setIdPhieuKham,
  setIdReceiptPrint,
} from "redux/reducer/common";
import { TT_PHIEU_KHAM } from "types/enums/examination";
import { examOutService, catalogService } from "api";
import Notification from "components/common/notification/notification";
import { listTTPhieuKham } from "data/list";
import {
  CancelButton,
  CompleteButton,
  PostponeButton,
  SaveButton,
  WaitingButton,
  SavePrintButton,
  CompletedKCB,
} from "./DetailTabInfo/components/ListButton/ListButton";

import PatientInfoCommon from "./PatientInfoCommon/PatientInfoCommon";
import ModalCustom from "components/common/ModalCustom/ModalCustom";
import ExamOutModal from "components/common/PrintReceipt/ExamOutModal/ExamOutModal";
import CheckNullApi from "components/common/CheckNullApi/CheckNullApi";
import AlertModal from "components/common/AlertModal/AlertModal";
const InforDetail = () => {
  //redux
  const modalRef = useRef<any>();
  const detailRef = useRef<any>();

  const activeTabKey = useAppSelector((state) => state.common.activeTab);
  // const listPhong = useAppSelector(state => state.common.listPhong);
  const [loading, setLoading] = useState(false);
  const [loadingCompleteKCB, setLoadingCompleteKCB] = useState(false);
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const [infoPatient, setInfoPatient] = useState<any>();
  const idPhieu = useAppSelector((state) => state.examination.idPKNT);
  const dataChanDoan = useAppSelector(
    (state) => state.examination.dataChanDoan
  );
  const bacSyKham = Form.useWatch("bacSyKham", form);
  const dataPhieu = useAppSelector((state) => state.examination.dataPhieu);
  const ref = useAppSelector((state) => state.examination.ref);
  const modalAlertRef = useRef<any>();
  const detailExamRef = useRef<any>();
  useEffect(() => {
    if (dataPhieu && idPhieu != null) {
      console.log("Mã phiếu", dataPhieu?.idPhieuKham);
      setPatientInfo(dataPhieu);
      if (
        dataPhieu?.trangThai == TT_PHIEU_KHAM.CTH ||
        dataPhieu?.trangThai == TT_PHIEU_KHAM.DCKQ
      ) {
        updateStatusPhieuKham(TT_PHIEU_KHAM.DTH);
      }
      dispatchCurrentRoom(
        dispatch,
        dataPhieu?.trangThai,
        TEN_PHONG.kham_ngoai_tru
      );
      dispatch(setIdReceiptPrint(dataPhieu?.id));
    }
  }, [dataPhieu]);

  useEffect(() => {
    if (activeTabKey === tabKeys.EXAMINATION.INFOR_DETAIL && dataPhieu) {
      dispatch(
        setButtonsHeader([
          CompletedKCB(handleCompleteKCB, loadingCompleteKCB),
          SaveButton(
            () => {
              handleSave();
            },
            dataPhieu?.trangThai,
            loadingCompleteKCB
          ),
          SavePrintButton(
            async () => {
              dispatch(setIdReceiptExamOut(null));
              await handleSave();
              modalRef.current?.openModal();
              dispatch(setIdReceiptExamOut(idPhieu));
            },
            dataPhieu?.trangThai,
            loadingCompleteKCB
          ),
          CompleteButton(async () => {
            const res = disableBtn(infoPatient?.ngayTao);
            if (res) {
              modalAlertRef.current.openModal();
              setLoading(false);
              return;
            }
            await handleSave();
            await updateStatusPhieuKham(TT_PHIEU_KHAM.HT);

            navigateToTabList();
          }, dataPhieu?.trangThai),
          // ReceiveButton(() => {
          //   getNextPatient();
          // }, dataPhieu?.trangThai),
          // ReceiveButton(()=>{}updateStatusPhieuKham()),
          CancelButton(() => {
            updateStatusPhieuKham(TT_PHIEU_KHAM.H);
          }, dataPhieu?.trangThai),
          PostponeButton(() => {
            updateStatusPhieuKham(TT_PHIEU_KHAM.CTH);
          }, dataPhieu?.trangThai),
          WaitingButton(() => {
            handleSave();
            updateStatusPhieuKham(TT_PHIEU_KHAM.CKQ);
          }, dataPhieu?.trangThai),
        ])
      );
    } else {
      dispatch(setButtonsHeader([]));
    }
  }, [activeTabKey, dataPhieu, dataChanDoan, loadingCompleteKCB]);
  const navigateToTabList = () => {
    dispatch(setActiveKey(tabKeys.EXAMINATION.LIST_EXAM));
  };
  useEffect(() => {
    getListTrangThaiTraThuoc();
    // console.log(
    //   JSON.parse(
    //     '{""intraocularPressureLeft"":[{"mmHg":"50","min":"","method":"ACT"}],""intraocularPressureRight"":[{"mmHg":"50","min":"","method":""}]}'
    //   )
    // );
  }, []);

  useEffect(() => {
    getPhieuKham();
  }, [idPhieu]);
  useEffect(() => {
    if (activeTabKey == tabKeys.EXAMINATION.INFOR_DETAIL) {
      getPhieuKham();
      CheckNullApi();
    }
  }, [activeTabKey]);
  const handleCompleteKCB = async () => {
    setLoadingCompleteKCB(true);
    await handleSave();
    try {
      await examinationService.completeKCB(dataPhieu?.idPhieuKham);

      Notification("success", "Đã hoàn thành khám chữa bệnh");
    } catch (error) {
      Notification("error", "Đã có lỗi khi hoàn thành khám chữa bệnh");
    }
    // await updateStatusPhieuKham(TT_PHIEU_KHAM.HT);
    setLoadingCompleteKCB(false);
    navigateToTabList();
  };
  const handleSave = async () => {
    setLoadingCompleteKCB(true);
    await updateChanDoan();
    detailRef.current?.handleSave();
    await updatePhieuKhamNgoaiTru();
    setLoadingCompleteKCB(false);
    await getPhieuKham();
  };
  const updatePhieuKhamNgoaiTru = async () => {
    try {
      const data = { ...dataPhieu, ...form.getFieldsValue() };
      await medicalExaminationService.updatePhieuKhamNgoaiTru(data);
      Notification("success", "Đã cập nhật thông tin phiếu");
    } catch (error) {}
  };

  const updateChanDoan = async () => {
    const data = {
      id: dataChanDoan?.id,
      idPhieuKhamNgoaiTru: idPhieu,
      jsonValue: localStorage.getItem("jsonValue"),
    };

    try {
      if (
        data.id != null &&
        isValuable(data?.jsonValue) &&
        data?.jsonValue != "{}"
      ) {
        await medicalExaminationService.updateDiagnostic(data, data.id);

        // dispatch(setDataChanDoan(res.data));
      } else {
        if (isValuable(data?.jsonValue) && data?.jsonValue != "{}") {
          const res = await medicalExaminationService.createDiagnostic(data);
          dispatch(setDataChanDoan(res.data));
        } else {
        }
        // Notification(
        //   "error",
        //   "Kết nối mạng có vấn đề. Vui lòng tải lại trang"
        // );
      }

      Notification("success", "Đã cập nhật thông tin chẩn đoán");
    } catch (error) {
      Notification("error", "Đã có lỗi khi cập nhật thông tin chẩn đoán");
    }
  };

  // useEffect(() => {}, [dataChanDoan]);
  // const getNextPatient = async () => {
  //   try {
  //     const res = await medicalExaminationService.getNextPatient();
  //     dispatch(setIdPKNT(res));
  //   } catch (error) {
  //     Notification("error", "Đã có lỗi khi lấy thông tin bệnh nhân tiếp theo");
  //   }
  // };
  const updateStatusPhieuKham = async (trangThai: TT_PHIEU_KHAM) => {
    const params = {
      trangThai: trangThai,
      id: idPhieu,
      bacSyKham: form.getFieldValue("bacSyKham"),
    };
    let tenTrangThai = listTTPhieuKham.find((e) => e.value == trangThai).label;

    try {
      const res = await examOutService.updateTrangThaiKBNT(params);
      dispatch(setDataPhieu(res));
      Notification("success", `Đã chuyển phiếu về trạng thái ${tenTrangThai}`);
      navigateToTabList();
      dispatch(setIdPKNT(null));
    } catch (err) {
      Notification(
        "error",
        `Đã có lỗi khi chuyển phiếu về trạng thái ${tenTrangThai}`
      );
    }
  };

  const onFinish = (values) => {};
  const getListTrangThaiTraThuoc = async () => {
    try {
      const res = await catalogService.getListTrangThaiTraThuoc();

      fieldsInforDetail1.find((e) => e.name == "trangThaiTraThuoc").options =
        await res.map((e) => {
          return { value: e.id, label: e.tenTTTraThuoc };
        });
    } catch (error) {
      Notification("error", "Đã có lỗi khi lấy danh sách trạng thái tra thuốc");
    }
  };

  useEffect(() => {
    if (!idPhieu) {
      dispatch(setActiveKey(tabKeys.EXAMINATION.LIST_EXAM));
    }
  }, [idPhieu]);

  const getPhieuKham = async () => {
    setLoading(true);
    if (idPhieu != null) {
      try {
        const res = await medicalExaminationService.getPKNTById({
          id: idPhieu,
        });
        dispatch(setDataPhieu(res));
        dispatch(setIdPhieuKham(res?.idPhieuKham));
        setInfoPatient(res);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        dispatch(setDataPhieu(null));

        Notification("error", "Lỗi khi lấy thông tin phiếu khám!");
      }
    } else {
      dispatch(setDataPhieu(null));
      setLoading(false);

      // Notification("warning", "Chưa chọn phiếu khám!");
    }
  };
  const setPatientInfo = (data) => {
    form.setFieldsValue({
      ...data,
      bacSyKham: data?.bacSyKham ?? localStorage.getItem("fullName"),
      ngayTao: convertIosStringToDate(data?.ngayTao),
      diUng: data?.diUng ?? "Không",
    });
  };

  useEffect(() => {
    dispatch(getListPhongAPI());
  }, []);

  // useEffect(() => {
  // fieldsInforDetail1.find(e => e.name == "loaiKCB").options = loaiKCB.map(
  //   it => ({value: it.id, label: it.tenLoaiKCB})
  // );
  // fieldsInforDetail2.find(e => e.name == "phong").options = listPhong.map(
  //   e1 => {
  //     return {
  //       value: e1.id,
  //       label: `${e1?.tenPhong} (${e1?.soBenhNhan})`,
  //     };
  //   }
  // );
  // fieldsInforDetail2.find(e => e.name == "trangThaiTraThuoc").options =
  //   trangThaiTraThuocOptions.map(e1 => {
  //     return {value: e1.id, label: e1.tenTTTraThuoc};
  //   });
  // fieldsInforDetail2.find(e => e.name == "trangThai").options =
  //   trangThaiPK.map(it => ({value: it.id, label: it.tenTTPhieuKham}));
  // setPatientInfo(dataPhieu);
  // }, [loaiKCB, trangThaiPK]);

  useEffect(() => {}, []);
  return (
    <div className="info-detail-container">
      <Spin spinning={loading}>
        <div>
          <Form labelAlign="left" form={form} onFinish={onFinish}>
            <div className="container">
              <Typography className="info-detail-title">
                Thông tin bệnh nhân
              </Typography>
              <Divider />
              <PatientInfoCommon data={infoPatient}></PatientInfoCommon>
            </div>
          </Form>
        </div>
        <div className="container">
          <StepInfo />
        </div>
        <div>
          <DetailTabInfo
            ref={detailRef}
            bacSyKham={bacSyKham}
            detailExamRef={detailExamRef}
          />
        </div>
      </Spin>

      <ModalCustom
        wrapClassName="modal-print-form"
        ref={modalRef}
        width={1000}
        centered
      >
        <ExamOutModal></ExamOutModal>
      </ModalCustom>
      {/* Cảnh báo quá hạn ngày */}
      <ModalCustom ref={modalAlertRef} width={600} title={"Cảnh báo"}>
        <AlertModal
          message={
            "Đã quá hạn hoàn thành cho phiếu khám. Vui lòng chọn hoàn thành khám chữa bệnh để hoàn thành phiếu!"
          }
        />
      </ModalCustom>
      {/* {activeTabKey === "1" ? <SupplyList /> : <></>} */}
    </div>
  );
};

export default InforDetail;
